import { render, staticRenderFns } from "./SingleImage2.vue?vue&type=template&id=d07046e8"
import script from "./SingleImage2.vue?vue&type=script&lang=ts"
export * from "./SingleImage2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports